import { Search, VisibilityRounded,CloseRounded as CloseIcon, Edit, SaveAltOutlined } from "@mui/icons-material";
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, GridLegacy as Grid, IconButton, Input, Modal, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { CustomAutoComplete, InputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance, DialogType } from "../../utils/constants";
import Checkbox from '@mui/material/Checkbox';




















const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

export const MaestroUnidadesMedidas = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({});



    useEffect(()=>{

      loadProducts();


    },[]);

    useEffect(()=>{
  
      loadProducts( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);
    const loadProducts =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros/obtener-unidades-medidas-paginacion",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

    const onSearchProductByName = (evt)=>{
      
      setFilterSearchPagination({...InitialFilterSearch,filter_search:evt.target.value});
    }

    const onShowDetailProduct = (cod_prod)=>{
      setIsVisibleModalDetalle(true);
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      setProductoSeleccionado(product || {});
    }
    const onCloseModalDetalle = ()=>{
      setIsVisibleModalDetalle(false);
    }
    const onChangeCheckBox = (evt,cod)=>{
      let newDataSet = [...dataSetProdctos];
      let indexItem = newDataSet.findIndex( item=>item.cod === cod );
      if ( indexItem !== -1){
        newDataSet[indexItem].ind_req_sobrecosto = newDataSet[indexItem].ind_req_sobrecosto === 1?0:1;
        setDataSetProductos(newDataSet);
      }
      console.log({evt:evt.target.value,cod});
    }
    const onSaveChangeItem = async(evt,cod)=>{
        console.log({cod});
        let itemToSave = dataSetProdctos.find( item=>item.cod === cod );
         if (itemToSave){
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:true
          });
          AxiosInstance.post("maestros/obtener-unidade-medida-update",{
            unidad_medida_cod:cod,
            requiere_proceso:itemToSave.ind_req_sobrecosto
          }).then(result=>{

            dispatch({
              type:ActionTypes.setModalInfo,
              data:{
                  title:"Cambio realizado",
                  message:"Sus cambios han sido guardados",
                  type:DialogType.exitoso,
                  isVisible:true
              }
          });

          }).catch(error=>{

            dispatch({
              type:ActionTypes.setModalInfo,
              data:{
                  title:"Error de comunicacion",
                  message:"Verifique su conexion a internet",
                  type:DialogType.exitoso,
                  isVisible:true
              }
          });

          }).finally(()=>{
            dispatch({
              type:ActionTypes.setLoadingPage,
              data:false
            });
          });

         }
    }
  
    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"cod_erp",
        keyValue:"cod_erp",
        label:"CODIGO ERP",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
      
        key:"descripcion",
        keyValue:"descripcion",
        label:"Descripcion",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"Estado",
        keyValue:"ind_estado",
        label:"Estado",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"Req. proceso?",
        keyValue:"ind_req_sobrecosto",
        label:"Req. proceso?",
        headerRender:(props)=>props.label,
        bodyRender:(props)=><Checkbox 
        onChange={e=>onChangeCheckBox(e,props.id)}
        sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
        checked={props.value === 1?true:false} />,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       /* {
      
        key:"ver-detalle",
        keyValue:"cod",
        label:"Editar",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><Button onClick={e=>onShowDetailProduct(value)} variant="contained" startIcon={<Edit/>} >Editar</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       }, */
       {
      
        key:"Guardar",
        keyValue:"cod",
        label:"Guardar",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><Button onClick={e=>onSaveChangeItem(e,value)} variant="contained" startIcon={<SaveAltOutlined/>} >Guardar</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },    
    ];

    return (<>
   {/*  {
      isVisibleModalDetalle &&
      <ModalEditarUnidad
      isVisible={isVisibleModalDetalle}
      productName={productoSeleccionado.descripcion}
      unidad_medida={productoSeleccionado.unidad_medida_nombre}
      Criterios={productoSeleccionado.detalle}
      OnCloseModalDetalle={onCloseModalDetalle}
      />
    } */}
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={4} >

            <InputWithLabel
              label="Buscar producto"
              inputType="text"
              onChange={onSearchProductByName}
              endAdornment={<Search />}
            />
        

        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell key={Col.key}  >
                          {<Col.bodyRender id={prod.cod} value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}